import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('request-sparepart/index', {params});
    },
    getCustomer(params) {
        return Service().get('request-sparepart/get-customer', {params});
    },
    show(id) {
        return Service().get('request-sparepart/show/'+id);
    },
    create(params) {
        return Service().post('request-sparepart/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('request-sparepart/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('request-sparepart/delete/'+id);
    },
}